module.exports = __webpack_public_path__ + "static/media/announcement-sample-view-maple.13a6fee0.png";